import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService, UIOrg } from '../../../auth/service/auth.service';

export interface OrgPickerDialogData {
  title: string;
  message: string;
  currentOrgId?: string;
}

@Component({
    selector: 'app-org-picker-dialog',
    templateUrl: './org-picker-dialog.component.html',
    styleUrls: ['./org-picker-dialog.component.scss'],
    standalone: false
})
export class OrgPickerDialogComponent implements OnInit {
  availableOrgs: UIOrg[] = [];
  selectedOrgId: string | null = null;
  currentOrgId: string;

  constructor(
    public dialogRef: MatDialogRef<OrgPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrgPickerDialogData,
    private authService: AuthService
  ) {
    this.currentOrgId = data.currentOrgId || this.authService.getSelectedOrgIdValue;
  }

  ngOnInit(): void {
    // Get all available organizations
    this.availableOrgs = this.authService.getOrgsValue;
    
    // Sort organizations by name
    this.availableOrgs.sort((a, b) => a.name.localeCompare(b.name));
    
    // Pre-select the current org if no other selection
    if (!this.selectedOrgId && this.availableOrgs.length > 0) {
      // Select a different org if possible
      const differentOrg = this.availableOrgs.find(org => org.id !== this.currentOrgId);
      this.selectedOrgId = differentOrg ? differentOrg.id : this.availableOrgs[0].id;
    }
  }

  onOrgSelect(orgId: string): void {
    this.selectedOrgId = orgId;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.selectedOrgId) {
      const selectedOrg = this.availableOrgs.find(org => org.id === this.selectedOrgId);
      this.dialogRef.close(selectedOrg);
    }
  }

  isCurrentOrg(orgId: string): boolean {
    return orgId === this.currentOrgId;
  }
}